import { render, staticRenderFns } from "./FeatureConfig.vue?vue&type=template&id=183786d2"
import script from "./FeatureConfig.js?vue&type=script&lang=js&external"
export * from "./FeatureConfig.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports